<template>
  <v-navigation-drawer
        v-model="utilsNav"
        overlay-color="primary"
        overlay-opacity="0.97"
        color="primary"
        fixed
        right
        temporary
      >

    <v-row class="ma-0 bg-white" justify="start">
      <v-col cols="auto">
        <v-btn
          elevation="2"
          icon
          color=""
          class="bg-primary"
          dark
          small
          @click="utilsNav=false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row class="ma-0" justify="start">
      <v-col cols="12" class="pa-0">
        <UtilsPanelStatic />
      </v-col>
    </v-row>
  </v-navigation-drawer>
</template>

<script>
import UtilsPanelStatic from './UtilsPanelStatic.vue'

export default {
  data: () => ({
      utilsNav: false,
      group: null,
    }),
    components: {
      UtilsPanelStatic,
    },
    computed: {
    },
    watch: {
      group () {
        this.drawer = false
      },
    },
    methods: {
      closeDrawer() {
        this.utilsNav = !this.utilsNav
      },

    },
    mounted() {
        this.$root.$on('closeDrawer', this.closeDrawer)
        
    },
  }
</script>

<style>

</style>